import { Action, handleActions } from 'redux-actions'
import {
  ActivityProgress,
  CountryActivityProgress,
  DivisionActivityProgress,
  DivisionId,
  GoalId,
  GroupView,
  GoalWithProgress,
} from '../../../services/api.types'
import {
  getCurrentCompanyGoalSuccess,
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  getCurrentGoalActivityListSuccess,
  setActivityListTab,
  setActivityListTypeTab,
} from './ActivityActions'

export enum ActivityView {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
  COUNTRY = 'COUNTRY',
}

interface GoalState {
  [goalId: string]: {
    goalId: GoalId
    activityView: ActivityView
    groupView: GroupView
    groupSum: boolean
    activityFilter: {
      countries: string[]
      divisionIds: DivisionId[]
    }
    userProgress: ActivityProgress
    activityProgress: ActivityProgress[]
    divisionActivityProgress: DivisionActivityProgress[]
    countryActivityProgress: CountryActivityProgress[]
    activityPeriodPercentage: number
    activityProgressLoading: boolean
    userIsInActivityList: boolean
  }
}

class State {
  userGoals: GoalWithProgress[] = []
  goalsDtoLoading = true
  goals: GoalState = {}
  activityListTab = 1
  activityListTypeTab = 1
  activityListTabSetAt = new Date().getTime()
}

export const activity = handleActions<State, any>(
  {
    [String(getCurrentGoalActivityList)]: (state: State, { payload = {} }: Action<any>): State => {
      const goalId = payload.goalId
      const newState = {
        ...state,
        goals: {
          ...state.goals,
          [goalId as GoalId]: {
            ...state.goals[goalId],
            activityProgressLoading: true,
          },
        },
      }
      if (newState.goals[goalId]) {
        if (payload.activityView) {
          newState.goals[goalId].activityView = payload.activityView
        }
        if (payload.activityFilter) {
          newState.goals[goalId].activityFilter = payload.activityFilter
        }
        if (payload.groupView) {
          newState.goals[goalId].groupView = payload.groupView
        }
        if (payload.groupSum !== undefined) {
          newState.goals[goalId].groupSum = payload.groupSum
        }
      }
      return newState
    },
    [String(getCurrentGoalActivityListSuccess)]: (state: State, { payload = {} }: Action<any>): State => {
      const goalId = payload.goalId
      const newState = {
        ...state,
        goals: {
          ...state.goals,
          [goalId as GoalId]: {
            ...state.goals[goalId],
            userProgress: payload.userProgress,
            activityFilter: payload.activityFilter,
            activityProgressLoading: false,
            userIsInActivityList: payload.userIsInActivityList,
            activityPeriodPercentage: payload.periodPercentage,
          },
        },
      }
      if (newState.goals[goalId]) {
        if (payload.activityProgress) {
          newState.goals[goalId].activityProgress = payload.activityProgress
        }
        if (payload.divisionActivityProgress) {
          newState.goals[goalId].divisionActivityProgress = payload.divisionActivityProgress
        }
        if (payload.countryActivityProgress) {
          newState.goals[goalId].countryActivityProgress = payload.countryActivityProgress
        }
      }
      return newState
    },
    [String(getCurrentGoalActivityListClear)]: (state: State, { payload = {} }: Action<any>): State => {
      const goalId = payload.goalId
      const newState = {
        ...state,
        goals: {
          ...state.goals,
          [goalId as GoalId]: {
            ...state.goals[goalId],
            activityProgressLoading: true,
          },
        },
      }
      if (!payload.updateGroupView || payload.clearAll) {
        newState.goals[goalId].activityProgress = []
      }
      if (payload.updateGroupView || payload.clearAll) {
        newState.goals[goalId].divisionActivityProgress = []
      }
      if (payload.clearAll) {
        newState.goals[goalId].countryActivityProgress = []
      }
      return newState
    },
    [String(getCurrentCompanyGoalSuccess)]: (state: State, { payload = [] }: Action<GoalWithProgress[]>): State => {
      return {
        ...state,
        userGoals: payload,
        goalsDtoLoading: false,
      }
    },
    [String(setActivityListTab)]: (state: State, { payload: activityListTab }: Action<number>): State => ({
      ...state,
      activityListTab,
      activityListTabSetAt: new Date().getTime(),
    }),
    [String(setActivityListTypeTab)]: (state: State, { payload: activityListTypeTab }: Action<number>): State => ({
      ...state,
      activityListTypeTab,
    }),
  },
  new State(),
)

export { State as ActivityState }
